import React, { useState } from "react";

import { Button, Stack } from "@mui/material";

import { State } from "./CreateReportSection";
import { GroupedColumnsPicker } from "./GroupedColumnsPicker";

interface Props {
  onCancel: () => void;
  onSubmit: (columns: State["table"]["columns"]) => void;
  selectedColumns: State["table"]["columns"];
  maxColumns?: number;
}

type Option = { type: keyof State["table"]["columns"]; value: string };

const selectedColumnsToState = (selectedColumns: State["table"]["columns"]) => {
  const result: Option[] = [];
  if (selectedColumns.measures.length) {
    selectedColumns.measures.forEach((item) => {
      result.push({ type: "measures", value: String(item) });
    });
  }
  if (selectedColumns.characteristics.length) {
    selectedColumns.characteristics.forEach((item) => {
      result.push({ type: "characteristics", value: String(item) });
    });
  }
  if (selectedColumns.calcFields.length) {
    selectedColumns.calcFields.forEach((item) => {
      result.push({ type: "calcFields", value: String(item) });
    });
  }
  return result;
};

const stateToColumns = (state: Option[]): State["table"]["columns"] => {
  const result: State["table"]["columns"] = {
    measures: [],
    characteristics: [],
    calcFields: []
  };
  state.forEach((item) => {
    if (item.type === "measures") {
      result.measures.push(item.value);
    }
    if (item.type === "characteristics") {
      result.characteristics.push(item.value);
    }
    if (item.type === "calcFields") {
      result.calcFields.push(item.value);
    }
  });
  return result;
};

export const TableColumnsPicker: React.FC<Props> = ({ onCancel, selectedColumns, onSubmit, maxColumns }) => {
  const [state, setState] = useState<Option[]>(selectedColumnsToState(selectedColumns));

  return (
    <Stack
      sx={{
        p: "20px 30px",
        gap: "20px",
        maxWidth: "580px",
        minWidth: "580px",
        borderRadius: "8px",
        boxShadow: "sm"
      }}
    >
      <Stack sx={{ p: "20px 0px", borderTop: "1px solid #dae0e2" }}>
        <GroupedColumnsPicker value={state} onChange={setState} maxColumns={maxColumns} />
      </Stack>
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", p: "0 30px", gap: "10px" }}>
        <Button variant="outlined" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" size="sm" onClick={() => onSubmit(stateToColumns(state))}>
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};
